import { ConfigPattern } from "../interfaces/paylivre"

export function resetConfigPattern(): ConfigPattern {
  let configPattern: ConfigPattern = {
    chaveAcesso: null
  }

  return {...configPattern}
}